import { render, staticRenderFns } from "./ProductNewButton.vue?vue&type=template&id=3018c95e&scoped=true&"
import script from "./ProductNewButton.vue?vue&type=script&lang=ts&"
export * from "./ProductNewButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductNewButton.vue?vue&type=style&index=0&id=3018c95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3018c95e",
  null
  
)

export default component.exports